import React from 'react';

import {assertAndContinue} from 'Asserts';
import RadioButtonGroup from 'ui-library/inputs/RadioButtonGroup';

import {LOOKUP_TYPES, LookupType} from './LookupFieldDefinitionConstants';

const OPTIONS_BY_LOOKUP_TYPE = {
  [LookupType.SAMPLE]: {
    value: LookupType.SAMPLE,
    label: 'Sample',
  },
  [LookupType.STAGE_RUN_INPUT]: {
    value: LookupType.STAGE_RUN_INPUT,
    label: 'Stage run input',
  },
  [LookupType.EXPERIMENTAL_CONDITION]: {
    value: LookupType.EXPERIMENTAL_CONDITION,
    label: 'Experimental condition',
  },
};

interface LookupTypeSelectorProps {
  supportedLookupTypes: Array<LookupType>;
  lookupType: LookupType;
  onChange: (lookupType: LookupType) => void;
}

const LookupTypeSelector: React.FC<LookupTypeSelectorProps> = (
  props: LookupTypeSelectorProps
): JSX.Element => {
  const orderedSupportedLookupTypes = LOOKUP_TYPES.filter((lookupType) =>
    props.supportedLookupTypes.includes(lookupType)
  );
  const options = [];
  for (const lookupType of orderedSupportedLookupTypes) {
    const option = OPTIONS_BY_LOOKUP_TYPE[lookupType];
    assertAndContinue(option != null, 'Expected option for lookup type', {lookupType});
    if (option) {
      options.push(option);
    }
  }

  return (
    <div>
      <RadioButtonGroup
        title="Lookup by"
        selectedValue={props.lookupType}
        options={options}
        onChange={props.onChange}
      />
    </div>
  );
};

export default LookupTypeSelector;
